<template>
  <div>
    <v-data-table
      v-if="propsHeader"
      :headers="headers"
      :items="zonesRendered"
      :loading="searching"
      :search="propsHeader.search"
      :sort-by="['region_name']"
      height="80vh"
      item-key="id"
      :items-per-page="-1"
      fixed-header
      :footer-props="{
      'page-text': 'Zones per page'
    }"
    >
      <!--<template slot="headers" scope="props">-->
      <!--<tr v-if="!scrolled">-->
      <!--&lt;!&ndash;:class="[scrolled ? {headerTable} : '']"&ndash;&gt;-->
      <!--<th v-for="header in headers" :key="header.text">{{header.text}}</th>-->
      <!--</tr>-->
      <!--<transition v-else name="fade">-->
      <!--<tr class="headerTable">-->
      <!--&lt;!&ndash;:class="[scrolled ? {headerTable} : '']"&ndash;&gt;-->
      <!--<th v-for="header in headers" :key="header.text">{{header.text}}</th>-->
      <!--</tr>-->
      <!--</transition>-->
      <!--</template>-->

      <template v-slot:item="props">
        <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" id="zonesHeader">
          <td style="text-align: center" @click="selectZone(props.item)">{{props.item.id}}</td>
          <td style="text-align: center" @click="selectZone(props.item)">{{props.item.region_name}}</td>
          <td style="text-align: center" @click="selectZone(props.item)">{{props.item.depot_name}}</td>
          <td style="text-align: center" @click="selectZone(props.item)">{{props.item.name}}</td>
          <td style="text-align: center" class="pa-0"
              v-for="(dayWeek, index) in days"
              :key="index"
              @click="selectZone(props.item)"
          >
            <div v-for="(hours, index) in props.item.tw_rendered[dayWeek]"
                 :key="index"
                 style="text-align: justify-all"
            >
              <div v-if="hours.in_use"
                   :class="{colorRed: (propsHeader.isInternalUser && hours.restricted), text: !(propsHeader.isInternalUser && hours.restricted)}">
                {{hours.time_start}} - {{hours.time_end}}
              </div>

              <div v-else
                   style="color: orange"
              >
                {{hours.time_start}} - {{hours.time_end}}
              </div>
            </div>
          </td>
          <td style="text-align: center" v-if="editPermission && propsHeader.client !== null">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn small icon outlined color="secondary" @click="clickEdit(props.item)" v-on="on">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <span>Edit this zone</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <EditZoneDialog
      :key="editDialogKey"
      :props="propsDialog"
      v-if="propsDialog.timeWindows"
      v-on:save-change="save"
      v-on:cancel-change="close"
      v-on:error="error"
    ></EditZoneDialog>
  </div>
</template>

<script>
    import EditZoneDialog from "./EditZoneDialog";
    import axios from 'axios'

    export default {
        name: "ZonesDataTable",
        components: {EditZoneDialog},
        props: {
            propsHeader: Object,
            zonesRendered: Array,
            searching: Boolean,
            selectZone: Function,
        },
        data() {
            return {
                // pagination: {'sortBy': 'region_name', 'ascending': true, 'rowsPerPage': -1},
                days: [
                    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
                ],
                propsDialog: {editZoneDialog: false, zone: null, timeWindows: null, editedIndex: -1, client: null,},
                editDialogKey: 0,
            }
        },
        methods: {
            error(message) {
                this.$emit('error', message);
            },
            clickEdit(item) {
                this.propsDialog.zone = item;
                this.propsDialog.editZoneDialog = true;
                this.propsDialog.editedIndex = this.zonesRendered.indexOf(item);
                this.propsDialog.client = this.propsHeader.client;

                axios.get(process.env.API_URL + '/regions/' + item.region_id + '/timewindows')
                    .then((response) => {
                        this.propsDialog.timeWindows = response.data;
                    })
                    .catch((response) => {
                        this.$emit('ERROR ' + response.response.data.error);
                    })
            },
            save(item) {

                // Stocking the selected ones

                let selected = {
                    Monday: [],
                    Tuesday: [],
                    Wednesday: [],
                    Thursday: [],
                    Friday: [],
                    Saturday: [],
                    Sunday: []
                };

                for (var k = 0; k < Object.keys(item).length; k++) {
                    for (var l = 0; l < Object.values(item)[k].length; l++) {
                        if (Object.values(item)[k][l].selected) {
                            selected[Object.keys(item)[k]].push(Object.values(item)[k][l]);
                        }
                    }
                }

                // Change item
                Object.assign(this.zonesRendered[this.propsDialog.editedIndex].tw_rendered, selected);

                // Update DataTable

                this.$emit('save-change');

                // Updating time_windows field
                this.propsDialog.zone.time_windows = [];
                for (var day_index = 0; day_index < Object.keys(this.propsDialog.zone.tw_rendered).length; day_index++) {
                    for (var tw_index = 0; tw_index < Object.values(this.propsDialog.zone.tw_rendered)[day_index].length; tw_index++) {
                        this.propsDialog.zone.time_windows.push(Object.values(this.propsDialog.zone.tw_rendered)[day_index][tw_index]);
                    }
                }

                // Reset values of editDialog

                this.close();

            },

            close() {
                this.propsDialog.timeWindows = null;
                this.propsDialog.editZoneDialog = false;
                this.propsDialog.editedIndex = -1;
            },
        },
        computed: {
            editPermission() {
                return this.$store.getters['auth/hasPermission']('zone_edit');
            },
            headers() {
                let headers = [
                    {
                        text: 'ID',
                        sortable: true,
                        align: 'center',
                        value: 'id',
                        width: '5%',
                    },
                    {
                        text: 'Region',
                        sortable: true,
                        align: 'center',
                        value: 'region_name',
                        width: '5%'

                    },
                    {
                      text: 'Depot',
                      sortable: true,
                      align: 'center',
                      value: 'depot_name',
                      width: '5%'

                    },
                    {
                        text: 'Zone Name',
                        sortable: true,
                        align: 'center',
                        value: 'name',
                        width: '5%'

                    },
                    {
                        text: 'Monday',
                        sortable: true,
                        align: 'center',
                        value: 'tw_rendered.monday.time_start',
                        width: '10%',
                    },
                    {
                        text: 'Tuesday',
                        sortable: false,
                        align: 'center',
                        value: 'tuesday',
                        width: '10%',

                    },
                    {
                        text: 'Wednesday',
                        sortable: false,
                        align: 'center',
                        value: 'wednesday',
                        width: '10%',

                    },
                    {
                        text: 'Thursday',
                        sortable: false,
                        align: 'center',
                        value: 'thursday',
                        width: '10%',

                    },
                    {
                        text: 'Friday',
                        sortable: false,
                        align: 'center',
                        value: 'friday',
                        width: '10%',

                    },
                    {
                        text: 'Saturday',
                        sortable: false,
                        align: 'center',
                        value: 'saturday',
                        width: '10%',

                    },
                    {
                        text: 'Sunday',
                        sortable: false,
                        align: 'center',
                        value: 'sunday',
                        width: '10%',

                    },
                ];
                if (this.editPermission && this.propsHeader.client !== null) {
                    headers.push({
                        text: 'Actions',
                        sortable: false,
                        align: 'center',
                        value: 'actions',
                        width: '5%',
                    })
                }
                return headers;
            }
        }
    }
</script>

<style scoped>

  .colorRed {
    color: red;
  }

  table.v-table tbody td, table.v-table tbody {
    height: 19px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ZonesDataTable.vue